export default __webpack_public_path__ + "static/shutterstock_251068444-c481d8a5c1e900301e8c2e369141b981.jpg";